module.exports = __webpack_public_path__ + "static/media/undraw_shopping_app_flsj.974cf793.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Landing/undraw_shopping_app_flsj.svg
// module id = 2857
// module chunks = 0